export class RoundingSettings {
    public minAxis: number;
    public maxAxis: number;
    public roundTo: number;
    public scale: number;
}

export class RoundingHelper {
    public static CalcRoundingSettingsForDiagram(nums: number[]) :RoundingSettings {
        nums = nums.filter(n => Number.isFinite(n));
        let max = Math.max(...nums);
        let min = Math.min(...nums);
        let maxMinDiff = max - min;
        let maxMinDiffPerc = Math.abs(maxMinDiff / max);
        const target = 0.33;
        let maxAxis = max + 0.2 * maxMinDiff;
        let minAxis = maxMinDiffPerc >= target ? (min > 0 ? 0 : min - (maxMinDiff * 0.2)) : max-maxMinDiff / target;
        if (minAxis == maxAxis)  {
            if (min != 0) {
                minAxis = minAxis * 0.95;
                maxAxis = maxAxis * 1.05;
            } else {
                minAxis = -1;
                maxAxis = 1;
            }
        }

        let a = Math.floor(Math.log10((Math.abs(maxAxis) + Math.abs(minAxis)) / 10.0));
        let roundTo = Math.pow(10, a);

        let absMin = Math.min(...nums.filter(n => n != 0).map(n => Math.abs(n)));
        if (!Number.isFinite(absMin)) {
            absMin = 1;
        }
        let scale = RoundingHelper.GetScale(absMin);
        return {
            roundTo: roundTo,
            maxAxis: maxAxis,
            minAxis: minAxis,
            scale: scale,
        }
    }

    public static CalcRoundingSettingsForNum(num: number): RoundingSettings {
        let scale = RoundingHelper.GetScale(num);
        let scaled = num / scale;
        let roundTo = Math.pow(10, Math.floor(Math.log10(Math.abs(num)/5)));
        if (Math.abs(scaled / roundTo) < 25) {
            roundTo /= 10;
        }

        return {
            roundTo: roundTo,
            scale: scale,
            maxAxis: undefined,
            minAxis: undefined,
        }
    }

    public static CalcRoundingSettingsForNums(nums: number[]): RoundingSettings {
        if (!nums.length) {
            return {
                roundTo: undefined,
                scale: undefined,
                maxAxis: undefined,
                minAxis: undefined,
            }
        }
        let avg = nums.reduce((a, b) => (a + b)) / nums.length;
        let min = Number.MAX_VALUE;
        for (let i = 0; i < nums.length; ++i) {
            if (min > Math.abs(nums[i])) {
                min = Math.abs(nums[i]);
            }
        }
        let num = Math.max(Math.abs(avg), min);
        return this.CalcRoundingSettingsForNum(num);
    }

    private static GetScale(num: number): number {
        let absNum = Math.abs(num);

        if (absNum < 0.001) {
            return 1.0/1000000;
        } else if (absNum < 0.1) {
            return 0.01;
        } else if (absNum < 1000) {
            return 1;
        } else if (absNum < 1000000) {
            return 1000;
        } else if (absNum < 1000000000) {
            return 1000000;
        } else {
            return 1000000000;
        }
    }
}